export const emptyJobDetails = {
    actualPickupDate: '0001-01-01T00:00:00Z',
    bbeNumber: '',
    creationDate: '',
    description: '',
    handoffLocation: '',
    id: -1,
    initialPlannedPickupDate: '0001-01-01T00:00:00Z',
    initialPlannedStagingDate: '0001-01-01T00:00:00Z',
    priorityName: '',
    purchaseOrder: '',
    revisedPickupDate: '0001-01-01T00:00:00Z',
    revisedStagingDate: '0001-01-01T00:00:00Z',
    statusName: '',
    totalShipments: 0,
    totalWeight: '',
    travelModeName: '',
    vendor: '',
  };

  export const priorityOptions =[
    { value: 'LO', label: 'Low' },
    { value: 'ST', label: 'Standard' },
    { value: 'RU', label: 'Rush' },
    { value: 'CR', label: 'Critical' },
  ];

  export const statusOptions = [
    { value: 'CREATED', label: 'Created' },
    { value: 'STAGED', label: 'Staged' },
    { value: 'READY', label: 'Ready of Pickup' },
    { value: 'IN_TRANSIT', label: 'In Transit' },
    { value: 'COMPLETED', label: 'Completed' },
  ];

  export const travelModeOptions = [
    { value: '0', label: 'N/A' },
    { value: '1', label: 'Road Only' },
    { value: '2', label: 'Flyable(Not Ideal)' },
    { value: '3', label: 'Flyable' },
    { value: '4', label: 'Sea/Barge' },
  ];
